// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_roW","cls2":"ArticlesFilters-cls2_jTy ArticlesFilters-cls1_roW"};